const colorsBlack = {
  'color-black': '#0C141C',
};

module.exports = colorsBlack;
